import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import { isYearlySubscriptionUtil } from 'modules/training/modules/subscription/utils/is-yearly-subscription/index.js'
import { isPremiumPlusSubscriptionUserUtil } from 'models/daos/user/utils/is-premium-plus-subscription/index.js'
import { SUBSCRIPTION_PLAN_PRICE } from '@gymaholic/packages'

const ANALYTIC_EVENT = {
  START_PREMIUM_FREE_TRIAL: 'START_PREMIUM_FREE_TRIAL',
  START_PREMIUM_FREE_TRIAL_YEARLY: 'START_PREMIUM_FREE_TRIAL_YEARLY',
  START_PREMIUM_PLUS_FREE_TRIAL: 'START_PREMIUM_PLUS_FREE_TRIAL',
  START_PREMIUM_PLUS_FREE_TRIAL_YEARLY: 'START_PREMIUM_PLUS_FREE_TRIAL_YEARLY',
  GET_PREMIUM: 'GET_PREMIUM',
  GET_PREMIUM_YEARLY: 'GET_PREMIUM_YEARLY',
  GET_PREMIUM_PLUS: 'GET_PREMIUM_PLUS',
  GET_PREMIUM_PLUS_YEARLY: 'GET_PREMIUM_PLUS_YEARLY',
  TRIAL_STARTED: 'TRIAL_STARTED',
  SUBSCRIPTION_STARTED: 'SUBSCRIPTION_STARTED'
}

/**
 * @param tokenId
 * @param isTrial
 * @returns {(function(*, *): Promise<void>)|*}
 */
export function logEventSubscribeToPlanTrainingUserActionUtil ({
  subscriptionPlan,
  isTrial
}) {
  const isYearly = isYearlySubscriptionUtil(subscriptionPlan)
  const isPremiumPlus = isPremiumPlusSubscriptionUserUtil(subscriptionPlan)

  const data = {
    value: isTrial ? 0 : SUBSCRIPTION_PLAN_PRICE[subscriptionPlan],
    currency: 'USD',
    plan: isYearly ? 'yearly' : 'monthly'
  }

  let event
  if (
    !isTrial &&
    isPremiumPlus
  ) {
    event = isYearly
      ? ANALYTIC_EVENT.GET_PREMIUM_PLUS_YEARLY
      : ANALYTIC_EVENT.GET_PREMIUM_PLUS
    data.tier = 'premium_plus'
  } else if (
    !isTrial &&
    !isPremiumPlus
  ) {
    event = isYearly
      ? ANALYTIC_EVENT.GET_PREMIUM_YEARLY
      : ANALYTIC_EVENT.GET_PREMIUM
    data.tier = 'premium'
  } else if (
    isTrial &&
    isPremiumPlus
  ) {
    event = isYearly
      ? ANALYTIC_EVENT.START_PREMIUM_PLUS_FREE_TRIAL_YEARLY
      : ANALYTIC_EVENT.START_PREMIUM_PLUS_FREE_TRIAL
    data.tier = 'premium_plus'
  } else if (
    isTrial &&
    !isPremiumPlus
  ) {
    event = isYearly
      ? ANALYTIC_EVENT.START_PREMIUM_FREE_TRIAL_YEARLY
      : ANALYTIC_EVENT.START_PREMIUM_FREE_TRIAL
    data.tier = 'premium'
  }

  logEventAnalyticsUtil(event, data)
}
